"use client";

import type { CSSProperties } from "react";

type LegalStampProps = {
  size?: number;
  className?: string;
  pulse?: boolean;
};

export default function LegalStamp({ size = 72, className = "", pulse = false }: LegalStampProps) {
  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 80 80"
        fill="none"
        aria-hidden="true"
        className={pulse ? "cp-stamp-pulse" : ""}
      >
        {/* Outer ring with distressed segments */}
        <circle cx="40" cy="40" r="38" stroke="#e8620a" strokeWidth="2" strokeDasharray="8 4" />
        <circle cx="40" cy="40" r="33" stroke="#e8620a" strokeWidth="0.8" opacity="0.5" />
        <circle cx="40" cy="40" r="28" stroke="#c0271a" strokeWidth="0.6" opacity="0.35" />

        {/* Top arc text */}
        <path
          id="stamp-top-arc"
          d="M 12,40 A 28,28 0 0,1 68,40"
          fill="none"
        />
        <text
          fill="#e8620a"
          fontSize="7"
          fontFamily="var(--cp-font-barlow-condensed), Arial Narrow, sans-serif"
          fontWeight="700"
          letterSpacing="0.18em"
          textAnchor="middle"
        >
          <textPath href="#stamp-top-arc" startOffset="50%">
            INTERDIT AUX
          </textPath>
        </text>

        {/* Bottom arc text */}
        <path
          id="stamp-bottom-arc"
          d="M 14,42 A 26,26 0 0,0 66,42"
          fill="none"
        />
        <text
          fill="#e8620a"
          fontSize="6.5"
          fontFamily="var(--cp-font-barlow-condensed), Arial Narrow, sans-serif"
          fontWeight="700"
          letterSpacing="0.16em"
          textAnchor="middle"
        >
          <textPath href="#stamp-bottom-arc" startOffset="50%">
            MOINS DE 18 ANS
          </textPath>
        </text>

        {/* Center 18+ */}
        <text
          x="42"
          y="40"
          textAnchor="middle"
          dominantBaseline="central"
          fill="#f5f0eb"
          fontSize="28"
          fontFamily="var(--cp-font-anton), Impact, sans-serif"
          fontWeight="400"
          letterSpacing="-0.01em"
        >
          18+
        </text>

        {/* Wanted stars */}
        <g fill="#e8620a">
          <path d="M18 24l1.2 3.2h3.4l-2.8 2 1.1 3.2-2.9-2.1-2.9 2.1 1.1-3.2-2.8-2h3.4z" />
          <path d="M62 24l1.2 3.2h3.4l-2.8 2 1.1 3.2-2.9-2.1-2.9 2.1 1.1-3.2-2.8-2h3.4z" />
        </g>
      </svg>
      <style>{`
        @keyframes cpStampPulse {
          0%, 100% { filter: drop-shadow(0 0 0 rgba(232,98,10,0)); transform: scale(1); }
          50% { filter: drop-shadow(0 0 10px rgba(232,98,10,0.35)); transform: scale(1.03); }
        }
        .cp-stamp-pulse {
          animation: cpStampPulse 3s ease-in-out infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .cp-stamp-pulse {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
}
